import React, { useState } from 'react';
import { NeoSplitSliderCardsView } from '../components/ui/NeoSplitSliderCardsView';
import NeoPageLayout from '../components/ui/NeoPageLayout';
import { useNavigate } from 'react-router-dom';
import PrivacyPolicyModal from '../components/modals/PrivacyPolicyModal';

const AboutView: React.FC = () => {
    const [isLoading, setIsPageLoading] = useState(true);
    const navigate = useNavigate();
    const [showTermsModal, setShowTermsModal] = useState(false);

    return (
        <>
            <NeoPageLayout
                pageTitle="About - ATS Global"
                pageDescription="Complete and Tailored AI Solutions"
                isLoading={isLoading}
                logoUrl={{
                    white: "/ATS_Global_Branding_SansNeo_White.png",
                    black: "ATS_Global_Branding_SansNeo_Black.png"
                }}
                logoStyle={{
                    height: "65px",
                }}
                logoAction={"/"}
                links={[
                    {
                        title: "project x",
                        action: "/project-x",
                    },
                    {
                        title: "about",
                        action: "/about",
                        active: true
                    },
                    // {
                    //     title: "blog",
                    //     action: "/blog",
                    // },
                    {
                        title: "team",
                        action: "/team",
                    },
                    {
                        title: "contact us",
                        action: "/contact-us",
                    },
                ]}
                mobileFooterLinks={[
                    {
                        title: "NeoAI",
                        action: "https://neoworlder.ai",
                    },
                    {
                        title: "NeoWorlder",
                        action: "https://neoworlder.com",
                    },
                    {
                        title: "Lootverse",
                        action: "https://lootverse.com",
                    },
                ]}
            >

                <NeoSplitSliderCardsView
                    id="about"
                    rightPaneTitle="About Us"
                    rightPaneSubtitle="We provide AI consulting services to help companies identify how AI can solve their unique business challenges. We also offer custom development and implementation of our suite of AI solutions, made-to-order."
                    leftPaneMediaType="image"
                    leftPaneMediaUrl="/About.jpg"
                    onNavigate={() => navigate("/team")}
                    onMediaLoaded={() => setIsPageLoading(false)}
                    textContentStyle={{ width: "632px" }}
                    items={[
                        {
                            title: "Best in class AI advisory ",
                            subtitle: "We’re practical people. We represent leading brands to tailor a solution that works.",
                            //  onExpand: () => setShowNeoAIDescriptionPopUp(true),
                        },
                        {
                            title: "Innovation",
                            subtitle: "Our parent company is involved in building leading AI systems. Get first access to these groundbreaking tools."
                        },
                        {
                            title: "Secure Application Management ",
                            subtitle: "We offer unique, isolated spaces for each application safeguarding your business data from any overlap or interference."
                        },
                        {
                            title: "Unleash Creativity with Customization",
                            subtitle: "AI solutions built to align with unique business goals."
                        },
                    ]}
                    footerContents={
                        <ul>
                            <li>
                                <a target="_blank" href="https://neoworlder.com">
                                    NeoWorlder.
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://neoworlder.ai">
                                    Neo AI.
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://lootverse.com">
                                    Lootverse.
                                </a>
                            </li>
                            <li onClick={() => setShowTermsModal(true)}>
                                <button>Terms.</button>
                            </li>
                        </ul>
                    }
                />
            </NeoPageLayout>

            {/* Terms of Use modal*/}
            <PrivacyPolicyModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />
        </>
    );
};

export default AboutView;
